import { IonApp } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { useQuantumMetric } from '@/hooks/useQuantumMetric';
import { useAppState } from '@/redux/hooks/app';
import { AppRoutes } from '@/routes';
import { getTheme } from '@/utils/getTheme';

function App() {
  useQuantumMetric();

  const { brand } = useAppState();
  const theme = brand ? getTheme(brand) : '';

  return (
    <IonApp className={theme}>
      <IonReactRouter basename={import.meta.env.VITE_BASE_PATH}>
        <Suspense>
          <Switch>
            <Redirect exact from="/" to="/my-visit" />
            <Redirect exact from="/:brand/my-visit" to="/my-visit" />
            <AppRoutes />
          </Switch>
        </Suspense>
      </IonReactRouter>
    </IonApp>
  );
}

export default App;
